import React, { useEffect } from "react";
import { Box, Container, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { AppBreadcrumbs } from "../components/common";

const TermsPage: React.FC = () => {
  useEffect(() => {
    console.debug("[DEBUG] Terms page viewed");
  }, []);

  return (
    <>
      <AppBreadcrumbs />
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Box sx={{ display: "grid", gap: 3 }}>
          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Acceptance
            </Typography>
            <Typography variant="body1">
              By creating an account or using Focus: Finance, you agree to these
              Terms and our{" "}
              <Link component={RouterLink} to="/privacy">
                Privacy Policy
              </Link>
              .
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Who We Serve
            </Typography>
            <Typography variant="body1">
              Focus: Finance is designed for individuals and small businesses to
              understand cash flow, track expenses, manage debts, and view
              financial insights. You must be at least 18 years old and able to
              enter into this agreement.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Account Security
            </Typography>
            <Typography variant="body1">
              Keep your login credentials secure and notify us of any
              unauthorized access. You are responsible for activity under your
              account.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Financial Data Connections
            </Typography>
            <Typography variant="body1">
              If you connect a financial institution, we use third-party
              providers (such as Plaid) to access account and transaction data.
              You authorize us to request and process that data to provide
              features like dashboards, categorization, and budgeting insights.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Features and Usage
            </Typography>
            <Typography variant="body1">
              Focus: Finance may include transaction tracking, AI
              categorization, expense linking, goals, debt sharing, group
              collaboration, and CSV import/export. You agree to use these tools
              lawfully and not to misuse or reverse engineer the service.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Not Financial Advice
            </Typography>
            <Typography variant="body1">
              Focus: Finance provides insights for informational purposes only.
              We do not provide financial, tax, or legal advice. You are
              responsible for decisions made using the service.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Third-Party Services
            </Typography>
            <Typography variant="body1">
              We integrate with third parties (such as Plaid for bank data and
              Stripe for connected accounts). Their terms may apply to your use
              of those services.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Availability and Changes
            </Typography>
            <Typography variant="body1">
              We may modify or discontinue features at any time. We will try to
              provide notice of material changes when reasonable.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Termination
            </Typography>
            <Typography variant="body1">
              You may stop using Focus: Finance at any time. We may suspend or
              terminate access for abuse, security risk, or legal reasons.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Contact
            </Typography>
            <Typography variant="body1">
              Questions? Email{" "}
              <Link href="mailto:support@financetracker.app">
                support@financetracker.app
              </Link>
              .
            </Typography>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default TermsPage;
